import {
  Component,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ModelsWrapperComponent } from '@app/pages/quote/standard-quote/models/models-wrapper.component';

@Component({
  selector: 'app-models-desktop',
  templateUrl: './models-desktop.component.html',
  styleUrls: ['./models-desktop.component.scss'],
})
export class ModelsDesktopComponent extends ModelsWrapperComponent {
  constructor(
    route: ActivatedRoute,
  ) {
    super(route);
  }
}
